<div [a7LayoutSection]="sectionTitle"
     [a7LayoutSectionDelta]="-300"
     [ngClass]="{ 'h-spacing-main-section-n': mobile }">

  <div *ngIf="topDivider"
       class="divider-outline-variant-mid v2-margin-8px-b"></div>
  <div *ngIf="sectionTitle"
       class="headline-lg flex-row-between-center"
       [ngClass]="{ 'h-spacing-main-section': titleBackground || mobile, 
       'bg-surface-container-low': titleBackground, 
       'v2-padding-20px-v': titleBackground,
       'col-gap-spacing-in-component-l': sectionIcon }">
    <div class="flex-row-start-center">
      <img *ngIf="sectionIcon"
           [src]="sectionIcon"
           class="v2-w-28px v2-h-28px v2-margin-4px-r v2-margin-4px-b" />
      <span class="color-on-surface">{{sectionTitle}}</span>
    </div>
    <ng-content select="[titleBarActions]"></ng-content>
  </div>
  <div [ngClass]="{  'margin-t-main-section-body': sectionTitle, 'h-spacing-main-section': titleBackground || mobile  }">
    <ng-content select="[sectionBody]"></ng-content>
  </div>
</div>
